import { render, staticRenderFns } from "./graphicsList2.vue?vue&type=template&id=77e4ce48"
import script from "./graphicsList2.vue?vue&type=script&lang=js"
export * from "./graphicsList2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports